import React, { Fragment } from "react";
import LoadingSpinner from "../../common/loading-spinner";
var FormSubmit = function FormSubmit(_ref) {
    var text = _ref.text, props = _ref.props, _ref$buttonClassName = _ref.buttonClassName, buttonClassName = _ref$buttonClassName === void 0 ? "btn-makroOrange" : _ref$buttonClassName;
    return /*#__PURE__*/ React.createElement(Fragment, null, props.isSubmitting && /*#__PURE__*/ React.createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ React.createElement(LoadingSpinner, null)), /*#__PURE__*/ React.createElement("button", {
        className: buttonClassName,
        type: "submit",
        disabled: JSON.stringify(props.touched) == "{}" || !props.isValid || props.isSubmitting
    }, text));
};
export default FormSubmit;
